import { render, staticRenderFns } from "./LayoutParent.vue?vue&type=template&id=30d18fa5&scoped=true&"
import script from "./LayoutParent.vue?vue&type=script&lang=js&"
export * from "./LayoutParent.vue?vue&type=script&lang=js&"
import style0 from "./LayoutParent.vue?vue&type=style&index=0&id=30d18fa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d18fa5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VAppBar,VAppBarNavIcon,VMain,VSpacer})
